/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-throw-literal */
import { CustomTable } from "../../../shared";
import * as React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { convertDate, errorMessage, sortItems } from "../../../utils";
import { DashBoardDateRangePicker } from "../../Dashboard";
import { useImmer } from "use-immer";
import { getClientAccountStatementListApi } from "../api";
import { useParams } from "react-router-dom";
import { ManageOnDemandStatement } from "./ManageOnDemandStatement";

export const StatementsList = ({ type }) => {
  const {
    state,
    onChangeDate,
    handleIsOpen,
    handleDateChangeApply,
    handleClearAllFilter,
    handleClearFilter,
    toggleOnDemandStatement,
  } = useStatementsList();

  const ActionButtons = ({ deleteAction }) => {
    return (
      <div className="action-buttons">
        <img
          alt="details"
          // onClick={editAction}
          src="/icons/arrow_forward.svg"
        />
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date Generated",
        accessor: "date_generated",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Billing Cycle",
        accessor: "billing_cycle_from",
        Cell: ({
          row: {
            original: { billing_cycle_from, billing_cycle_to },
          },
        }) => {
          return (
            <Typography fontSize="14px" fontWeight={400}>
              {billing_cycle_from} - {billing_cycle_to}
            </Typography>
          );
        },
        sortType: (prev, curr, columnId) => {
          console.log(prev, curr, columnId);
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Due Date",
        accessor: "due_date",
      },

      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return (
            <ActionButtons
              deleteAction={() => {
                // handleModal("ledger-delete", true, row.id)
              }}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <CustomTable
        isLoading={state.statement.loading}
        columns={columns}
        data={state.statement.list}
        searchBar={false}
        tableTitle="Statements"
        headerRightContent={
          <Stack direction="row" gap="16px">
            <DashBoardDateRangePicker
              onChangeDate={onChangeDate}
              isList={true}
              range={state.statement.filter.date.value}
              showRange={state.statement.filter.date.showDate}
              isOpen={state.statement.filter.date.isCalenderOpen}
              handleIsOpen={handleIsOpen}
              handleDateChangeApply={handleDateChangeApply}
              className="dashBoard-calender"
              label="Date Range"
            />
            <Button
              type="button"
              size="medium"
              variant="contained"
              onClick={() => toggleOnDemandStatement(true)}
            >
              On Demand Statement
            </Button>
          </Stack>
        }
        filterApplied={state.statement.appliedFilters}
        onAllFilterClear={handleClearAllFilter}
        onFilterClear={handleClearFilter}
        onRowLink={(row) => `statement/${row.id}`}
      />

      <ManageOnDemandStatement
        open={state.isOpenOnDemandStatement}
        handleClose={() => toggleOnDemandStatement(false)}
      />
    </React.Fragment>
  );
};

const defaultDateObject = {
  isCalenderOpen: false,
  value: [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ],
  showDate: [],
};

const useStatementsList = () => {
  const { id } = useParams();
  const [state, setState] = useImmer({
    statement: {
      list: [],
      loading: true,
      filter: { date: defaultDateObject },
      appliedFilters: [],
    },
    isOpenOnDemandStatement: false,
  });

  const getClientAccountStatements = async ({ clientAccountId, params }) => {
    triggerTableLoading(true);
    try {
      const response = await getClientAccountStatementListApi({
        clientAccountId,
        params,
      });

      const { success, message, data } = response;

      if (success) {
        setState((draft) => {
          draft.statement.list = data;
        });
      } else {
        throw {
          response: { data: { message } },
        };
      }
    } catch (error) {
      const message =
        error.response.data?.message ??
        "Failed to fetch client account statements";
      errorMessage(message);
    } finally {
      triggerTableLoading(false);
    }
  };

  const triggerTableLoading = (loading) => {
    setState((draft) => {
      draft.statement.loading = loading;
    });
  };

  const onChangeDate = async (event) => {
    setState((draft) => {
      draft.statement.filter.date.value = event;
    });
  };

  const handleIsOpen = async (e) => {
    setState((draft) => {
      draft.statement.filter.date.isCalenderOpen = e;
    });
  };

  const getFilterPrams = async (date) => {
    const { startDate, endDate } = date.value[0];

    const filter =
      date.showDate.length > 0
        ? {
            start_date: convertDate({ date: startDate }),
            end_date: convertDate({ date: endDate }),
          }
        : {};

    return filter;
  };

  const handleDateChangeApply = async () => {
    setState((draft) => {
      draft.statement.filter.date.showDate = state.statement.filter.date.value;
      draft.statement.filter.date.isCalenderOpen = false;
      draft.statement.appliedFilters = [
        {
          label: `${convertDate({
            date: state.statement.filter.date.value[0].startDate,
            format: "MMM DD, YYYY",
          })} to ${convertDate({
            date: state.statement.filter.date.value[0].endDate,
            format: "MMM DD, YYYY",
          })}`,
          type: "Date Range",
        },
      ];
    });

    if (state.statement.filter.date.value.length > 0) {
      const params = await getFilterPrams({
        ...state.statement.filter.date,
        showDate: state.statement.filter.date.value,
      });
      await getClientAccountStatements({ clientAccountId: id, params });
    }
  };

  // Function to handle reset the specific filter
  const handleClearFilter = (e) => handleClearAllFilter();

  // Function to handle reset all filter
  const handleClearAllFilter = async () => {
    setState((draft) => {
      draft.statement.filter.date = defaultDateObject;
      draft.statement.appliedFilters = [];
    });
    await getClientAccountStatements({ clientAccountId: id });
  };

  const toggleOnDemandStatement = (status) => {
    setState((draft) => {
      draft.isOpenOnDemandStatement = status;
    });
  };

  React.useEffect(() => {
    getFilterPrams(state.statement.filter.date).then(async (params) => {
      await getClientAccountStatements({ clientAccountId: id, params });
    });
  }, []);

  return {
    state,
    onChangeDate,
    handleIsOpen,
    handleDateChangeApply,
    handleClearFilter,
    handleClearAllFilter,
    toggleOnDemandStatement,
  };
};
